/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddFittingModeComponent } from './add-fitting-mode.component';
import { AddFittingTabModule } from '../add-fitting-tab/add-fitting-tab.module';
import { ResultContainerModule } from '../result-container';
import { AddFittingPanelFrameModule } from '../add-fitting-panel-frame';
import { DxButtonModule } from 'devextreme-angular';
import { AlertModule } from '../../../../../../shared/ui/src/lib/components/alert';

@NgModule({
  declarations: [
    AddFittingModeComponent
  ],
  imports: [
    CommonModule,
    AddFittingTabModule,
    ResultContainerModule,
    AddFittingPanelFrameModule,
    AlertModule,
    DxButtonModule,
  ],
  exports: [AddFittingModeComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AddFittingModeModule { }